export default __webpack_public_path__ + "static/3-63cb8bcd607c4155c4249209317210d0.png";